export class OverreadFeedbackQuerySearch {
  constructor(
    readonly codingUserId?: number,
    readonly qaUserId?: number,
    readonly managerUserId?: number,
    readonly codingReceiptStatus?: string,
    readonly qaReceiptStatus?: string,
    readonly chaseOverreadFeedbackStatus?: string,
    readonly measureId?: number,
    readonly sortDirection?: string,
    readonly sortField?: string,
    readonly startRecord?: number,
    readonly endRecord?: number,
    readonly getNextFilter?: number
  ) {
    this.codingUserId = codingUserId;
    this.qaUserId = qaUserId;
    this.managerUserId = managerUserId;
    this.codingReceiptStatus = codingReceiptStatus;
    this.qaReceiptStatus = qaReceiptStatus;
    this.chaseOverreadFeedbackStatus = chaseOverreadFeedbackStatus;
    this.measureId = measureId;
    this.sortDirection = sortDirection;
    this.sortField = sortField;
    this.startRecord = startRecord;
    this.endRecord = endRecord;
    this.getNextFilter = getNextFilter;
  }
}
